export default "__VITE_ASSET__eec83fd3__"